export default __webpack_public_path__ + "static/media/raiffeisen_background_s2.ab06c67e.jpg";